import { VersioningBanner } from './versioning-banner';
import { VersioningMakeOS } from './versioning-make-os';

export class VersioningProject {
  approvedExport: string;
  banners: VersioningBanner[] = new Array<VersioningBanner>();
  originalData: any;
  rootRepo: string;
  time: Date;
  timeStamp: string;
  previewBanner: VersioningBanner;
  previewBannerLink: string;
  masterFolderBaseName: string; // folder where the banner is placed, not full computer path
  masterProjectBaseName: string;
  makeOSProject: VersioningMakeOS;

  tmpFolderBaseName: string;
  newHTMLBaseName: string;

  constructor(data: any) {
    if (typeof data === 'undefined') {
      data = {};
    }

    this.time = typeof data.time !== 'undefined' ? new Date(Date.parse(data.time)) : new Date();
    this.timeStamp = typeof data.timeStamp !== 'undefined' ? data.timeStamp : this.time.getTime();
    this.banners = typeof data.banners !== 'undefined' && Array.isArray(data.banners) ? data.banners.map((r: any) => new VersioningBanner(r)) : [];

    this.makeOSProject = typeof data.makeOSProject !== 'undefined' ? new VersioningMakeOS(data.makeOSProject) : new VersioningMakeOS({});

    this.approvedExport =
      typeof this.makeOSProject !== 'undefined' && typeof this.makeOSProject.approvedExport !== 'undefined' ? this.makeOSProject.approvedExport : '?????';

    this.rootRepo = typeof data.rootRepo !== 'undefined' ? data.rootRepo : '';
    const previewBanner = this.banners.filter(
      (r: VersioningBanner) => r.width === this.makeOSProject.previewSize.width && r.height === this.makeOSProject.previewSize.height,
    );
    const bannerIndex0: VersioningBanner = this.banners.length > 0 ? this.banners[0] : new VersioningBanner({});
    this.previewBanner = previewBanner.length === 1 ? previewBanner[0] : bannerIndex0;

    const previewBannerLink = 'export/' + this.approvedExport + '/' + this.previewBanner.versioningLine.bannerWebPath;
    this.previewBannerLink = previewBannerLink
      .split('/')
      .filter((r: string) => r.replace(/[^a-z0-9]/gim, '').trim().length !== 0)
      .join('/');

    this.masterProjectBaseName = typeof data.masterProjectBaseName !== 'undefined' ? data.masterProjectBaseName : 'masterProjectBaseName_not_defined';
    this.masterFolderBaseName =
      this.masterProjectBaseName + '/export/' + this.approvedExport + '/' + this.previewBanner.versioningLine.indexWithPrefix + '/html';

    this.tmpFolderBaseName = typeof data.tmpFolderBaseName !== 'undefined' ? data.tmpFolderBaseName : '';

    this.newHTMLBaseName = typeof data.newHTMLBaseName !== 'undefined' ? data.newHTMLBaseName : '';

    this.originalData = Object.assign({}, data);
  }
}
